import { DropdownOptionType } from '@Components/Dropdown/Type';
import { postFedExDetails } from '@Reducers/AdminShipment/actions';
import { AppDispatch } from '@Store';
import * as Yup from 'yup';

/* ------------------------------- OPTIONS ------------------------------- */

export const TermsOfDeliveryOptions: DropdownOptionType[] = [
  {
    value: 'DAP',
    display: 'DAP',
  },
  {
    value: 'DT1',
    display: 'DT1',
  },
];

export const ExportReasonOptions: DropdownOptionType[] = [
  {
    value: '01',
    display: 'Sale',
  },
  {
    value: '02',
    display: 'Return / Replacement',
  },
  {
    value: '03',
    display: 'Gift',
  },
];

export const CurrencyOptions: DropdownOptionType[] = [
  {
    value: 'GBP',
    display: 'GBP',
  },
  {
    value: 'EUR',
    display: 'EUR',
  },
  {
    value: 'USD',
    display: 'USD',
  },
];

export const InvoiceTypeOptions: DropdownOptionType[] = [
  {
    value: '1',
    display: 'Proforma',
  },
  {
    value: '2',
    display: 'Commercial',
  },
];

/* --------------------------- DEFAULT VALUES ---------------------------- */

export const dpdukInitialValues: dpdukInformationSchema = {
  type: '',
  csp: 'dpduk',
  awbShowToUser: false,
  accountNo: '',
  countryOfManufacture: '',
  exporterEoriNumber: '',
  termsOfDelivery: '',
  exportReason: '',
  currency: '',
  invoiceType: '',
  networkCode: '1^19',
};

/* ----------------------------- VALIDATION ------------------------------ */

export const dpdukInformationValidation = Yup.object().shape({
  type: Yup.string().required('Type is required'),

  accountNo: Yup.string().required('Account Number is required'),

  countryOfManufacture: Yup.string().required('Country Of Manufacture is required'),

  exporterEoriNumber: Yup.string().required('Exporter EORI Number is required'),

  termsOfDelivery: Yup.string().oneOf(['DAP', 'DT1']).required('Terms Of Delivery is required'),

  exportReason: Yup.string().oneOf(['01', '02', '03']).required('Export Reason is required'),

  currency: Yup.string().oneOf(['GBP', 'EUR', 'USD']).required('Currency is required'),

  invoiceType: Yup.string().oneOf(['1', '2']).required('Invoice Type is required'),

  networkCode: Yup.string().required('Network Code is required'),
});

/* ------------------------------ INTERFACE ------------------------------ */

export interface dpdukInformationSchema {
  type: string;
  csp: string;
  awbShowToUser: boolean;
  accountNo: string;
  countryOfManufacture: string;
  exporterEoriNumber: string;
  termsOfDelivery: string;
  exportReason: string;
  currency: string;
  invoiceType: string;
  networkCode: string;
}

/* ------------------------------ API CALL ------------------------------- */

export const onForward = ({
  values,
  shipmentNumber,
  dispatch,
  nextFunc,
}: {
  values: dpdukInformationSchema;
  shipmentNumber: string;
  dispatch: AppDispatch;
  nextFunc: () => void;
}) => {
  const body = {
    ...JSON.parse(JSON.stringify(values)),
  };
  delete body.response;

  for (const key in body) {
    if (body[key]) {
      if (key === 'accountNo') {
        body[key] = body[key]?.split('-')?.[0];
      }
    }
  }

  dispatch(
    postFedExDetails({
      shipmentNumber: `${shipmentNumber}`,
      body,
      date: null,
      nextFunc,
    }),
  );
};
